import * as apiCaller from "api/apiCaller";
import axios from "axios";
import { DEPARTMENT_QUEUE_TYPES } from "constant";
import API_URL from "constant/api-url";
import { isNil } from "lodash";
import { bindActionCreators } from "redux";
import { all, call, put, select, take, takeLatest } from "redux-saga/effects";

export const SET_RINGME_OTT_SDK = "SET_RINGME_OTT_SDK";
export const SET_THREAD_INFO = "SET_THREAD_INFO";
export const SET_IS_AUTHENTICATED_SDK = "SET_IS_AUTHENTICATED_SDK";
export const GET_LIST_CHAT_TICKET_HISTORY = "GET_LIST_CHAT_TICKET_HISTORY";
export const SET_LIST_CHAT_TICKET_HISTORY = "SET_LIST_CHAT_TICKET_HISTORY";
export const SET_LOADING_LIST_CHAT_TICKET_HISTORY =
  "SET_LOADING_LIST_CHAT_TICKET_HISTORY";

export const SET_LOADING_CHANGE_AGENT_CHAT_STATUS =
  "SET_LOADING_LIST_CHAT_TICKET_HISTORY";
export const SET_AGENT_CHAT_STATUS = "AGENT_CHAT_STATUS";
export const CHANGE_AGENT_CHAT_STATUS = "CHANGE_AGENT_CHAT_STATUS";
export const SET_USER_CHAT_INFO = "SET_USER_CHAT_INFO";
export const SET_AGENT_CHAT_STATISTIC = "SET_AGENT_CHAT_STATISTIC";
export const GET_AGENT_CHAT_STATISTIC = "GET_AGENT_CHAT_STATISTIC";
export const SET_STATE = "SET_STATE";
export const GET_CUSTOMER_CHAT_HISTORY = "GET_CUSTOMER_CHAT_HISTORY";
export const SET_CUSTOMER_CHAT_HISTORY = "SET_CUSTOMER_CHAT_HISTORY";
export const GET_RINGME_REPORT_CHAT_BY_HOUR = "GET_RINGME_REPORT_CHAT_BY_HOUR";
export const SET_RINGME_REPORT_CHAT_BY_HOUR = "SET_RINGME_REPORT_CHAT_BY_HOUR";
export const GET_RINGME_REPORT_CHAT_BY_DATE = "GET_RINGME_REPORT_CHAT_BY_DATE";
export const SET_RINGME_REPORT_CHAT_BY_DATE = "SET_RINGME_REPORT_CHAT_BY_DATE";
export const SET_LOADING_RINGME_REPORT_CHAT_BY_DATE =
  "SET_LOADING_RINGME_REPORT_CHAT_BY_DATE";
export const GET_RINGME_LIST_CHAT_QUEUE_ID = "GET_RINGME_LIST_CHAT_QUEUE_ID";
export const SET_RINGME_LIST_CHAT_QUEUE_ID = "SET_RINGME_LIST_CHAT_QUEUE_ID";

// ringmeOttSdk: SDK bên gotech tích hợp cho app OneCX
const initialState = {
  ringmeOttSdk: null,
  threadInfo: null, // thread chat hiện tại
  isAuthenticatedSdk: false,
  listChatTicketHistory: [],
  loadingListChatTicketHistory: false,
  agentChatStatus: "",
  userChatInfo: null,
  customerChatHistory: [],
  loadingCustomerChatHistory: false,
  ringmeReportChatByHour: null,
  ringmeReportChatByDate: null,
  loadingRingmeReportChatByDate: false,
  listChatQueueId: [],
};

export const ringmeOttSdkReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_STATE:
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      };

    case SET_USER_CHAT_INFO:
      return {
        ...state,
        userChatInfo: action.payload,
      };

    case SET_RINGME_OTT_SDK:
      return {
        ...state,
        ringmeOttSdk: action.payload,
      };

    case SET_IS_AUTHENTICATED_SDK:
      return {
        ...state,
        isAuthenticatedSdk: action.payload,
      };

    case SET_THREAD_INFO:
      return {
        ...state,
        threadInfo: action.payload,
      };

    case SET_LIST_CHAT_TICKET_HISTORY:
      return {
        ...state,
        listChatTicketHistory: action.payload,
      };

    case SET_LOADING_LIST_CHAT_TICKET_HISTORY:
      return {
        ...state,
        loadingListChatTicketHistory: action.payload,
      };

    case SET_AGENT_CHAT_STATUS:
      return {
        ...state,
        agentChatStatus: action.payload,
      };

    case SET_AGENT_CHAT_STATISTIC:
      return {
        ...state,
        agentChatStatistic: action.payload,
      };

    case SET_CUSTOMER_CHAT_HISTORY:
      return {
        ...state,
        customerChatHistory: action.payload,
      };

    case SET_RINGME_REPORT_CHAT_BY_HOUR:
      return {
        ...state,
        ringmeReportChatByHour: action.payload,
      };

    case SET_RINGME_REPORT_CHAT_BY_DATE:
      return {
        ...state,
        ringmeReportChatByDate: action.payload,
      };

    case SET_LOADING_RINGME_REPORT_CHAT_BY_DATE:
      return {
        ...state,
        loadingRingmeReportChatByDate: action.payload,
      };

    case SET_RINGME_LIST_CHAT_QUEUE_ID:
      return {
        ...state,
        listChatQueueId: action.payload,
      };

    default:
      return state;
  }
};

export const setRingmeOttSdk = (payload) => ({
  type: SET_RINGME_OTT_SDK,
  payload,
});

export const setUserChatInfo = (payload) => ({
  type: SET_USER_CHAT_INFO,
  payload,
});

export const setThreadInfo = (payload) => ({
  type: SET_THREAD_INFO,
  payload,
});

export const setIsAuthenticatedSdk = (payload) => ({
  type: SET_IS_AUTHENTICATED_SDK,
  payload,
});

export const setListChatTicketHistory = (payload) => ({
  type: SET_LIST_CHAT_TICKET_HISTORY,
  payload,
});

export const setLoadingListChatTicketHistory = (payload) => ({
  type: SET_LOADING_LIST_CHAT_TICKET_HISTORY,
  payload,
});

export const getListChatTicketHistoryByUsername = (phoneNumber) => ({
  type: GET_LIST_CHAT_TICKET_HISTORY,
  payload: phoneNumber,
});

export const changeAgentChatStatus = (status) => ({
  type: CHANGE_AGENT_CHAT_STATUS,
  payload: status,
});

export const getAgentChatStatistic = (payload) => ({
  type: GET_AGENT_CHAT_STATISTIC,
  payload,
});

export const setAgentChatStatus = (payload) => ({
  type: SET_AGENT_CHAT_STATUS,
  payload,
});

export const getCustomerChatHistory = (params) => ({
  type: GET_CUSTOMER_CHAT_HISTORY,
  payload: params,
});

export const setCustomerChatHistory = (payload) => ({
  type: SET_CUSTOMER_CHAT_HISTORY,
  payload,
});

export const getRingmeReportChatByHour = (payload) => ({
  type: GET_RINGME_REPORT_CHAT_BY_HOUR,
  payload,
});

export const setRingmeReportChatByHour = (payload) => ({
  type: SET_RINGME_REPORT_CHAT_BY_HOUR,
  payload,
});

export const setRingmeReportChatByDate = (payload) => ({
  type: SET_RINGME_REPORT_CHAT_BY_DATE,
  payload,
});

export const getRingmeReportChatByDate = (payload) => ({
  type: GET_RINGME_REPORT_CHAT_BY_DATE,
  payload,
});

export const getRingmeListChatQueueId = (payload) => ({
  type: GET_RINGME_LIST_CHAT_QUEUE_ID,
  payload,
});

export const setRingmeListChatQueueId = (payload) => ({
  type: SET_RINGME_LIST_CHAT_QUEUE_ID,
  payload,
});

export const setLoadingRingmeReportChatByDate = (payload) => ({
  type: SET_LOADING_RINGME_REPORT_CHAT_BY_DATE,
  payload,
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      getRingmeReportChatByHour,
      getRingmeReportChatByDate,
      getRingmeListChatQueueId,
    },
    dispatch
  );
};

// flow
export const fetchListChatTicketHistory = function* (action) {
  if (isNil(action.payload)) {
    yield put({
      type: SET_LIST_CHAT_TICKET_HISTORY,
      payload: [],
    });
  } else {
    yield put({
      type: SET_LOADING_LIST_CHAT_TICKET_HISTORY,
      payload: true,
    });
    try {
      const res = yield call(getListChatTicketHistoryApi, {
        phone: action.payload,
      });
      yield put({
        type: SET_LIST_CHAT_TICKET_HISTORY,
        payload: res.data,
      });
    } catch (error) {
      yield put({
        type: SET_LIST_CHAT_TICKET_HISTORY,
        payload: [],
      });
    }
    yield put({
      type: SET_LOADING_LIST_CHAT_TICKET_HISTORY,
      payload: false,
    });
  }
};

export const fetchAgentChatStatisticFlow = function* () {
  while (true) {
    yield take(GET_AGENT_CHAT_STATISTIC);
    try {
      const res = yield call(getAgentChatStatisticApi);
      yield put({
        type: SET_AGENT_CHAT_STATISTIC,
        payload: res.data,
      });
    } catch (error) {
      console.error(error);
    }
  }
};

export const fetchCustomerChatHistoryFlow = function* (action) {
  yield put({
    type: SET_STATE,
    payload: {
      name: "loadingCustomerChatHistory",
      value: true,
    },
  });
  try {
    const res = yield call(getCustomerChatHistoryApi, action.payload);
    yield put({
      type: SET_CUSTOMER_CHAT_HISTORY,
      payload: res.data?.data || [],
    });
  } catch (error) {
    console.error(error);
  }
  yield put({
    type: SET_STATE,
    payload: {
      name: "loadingCustomerChatHistory",
      value: false,
    },
  });
};

export const fetchRingmeReportChatByHourFlow = function* (action) {
  try {
    const { chatDepartmentId, date, from_hour, to_hour, type } = action.payload;

    const listChatQueueId = yield select(
      (state) => state.ringmeOttSdk.listChatQueueId
    );

    let queue_names = [];

    if (chatDepartmentId) {
      const queueId = listChatQueueId.find(
        (queue) => queue.chatDepartmentId === chatDepartmentId
      )?.queueId;

      if (queueId)
        queue_names.push({
          queue_name: queueId,
        });
    } else {
      queue_names = listChatQueueId
        .filter((queue) => Boolean(queue.queueId))
        .map((queue) => ({
          queue_name: queue.queueId,
        }));
    }

    if (queue_names.length === 0) {
      yield put(setRingmeReportChatByHour([]));
      return;
    }

    const params = {
      date,
      from_hour,
      to_hour,
      type,
    };
    const payload = {
      queue_names,
    };

    const res = yield call(getRingmeReportChatByHourApi, {
      params,
      payload,
    });

    const reportChatByHour = res.data.data.reduce(
      (prevValue, reportByQueue) => {
        reportByQueue.data_report.forEach((reportHourOfQueue) => {
          const specificHour = prevValue.find(
            (element) => element.hour === reportHourOfQueue.hour
          );
          if (specificHour) {
            specificHour.report = {
              done_thread:
                specificHour.report.done_thread +
                reportHourOfQueue.report.done_thread,
              missed_thread:
                specificHour.report.missed_thread +
                reportHourOfQueue.report.missed_thread,
            };
          } else {
            prevValue.push({
              hour: reportHourOfQueue.hour,
              report: reportHourOfQueue.report,
            });
          }
        });
        return prevValue;
      },
      []
    );

    yield put(setRingmeReportChatByHour(reportChatByHour));
  } catch (error) {
    console.error(error);
  }
};

export const fetchRingmeReportChatByDateFlow = function* (action) {
  yield put(setLoadingRingmeReportChatByDate(true));

  try {
    const listChatQueueId = yield select(
      (state) => state.ringmeOttSdk.listChatQueueId
    );

    const { chatDepartmentId, from_date, to_date, type } = action.payload;

    let queue_names = [];

    if (chatDepartmentId) {
      const queueId = listChatQueueId.find(
        (queue) => queue.chatDepartmentId === chatDepartmentId
      )?.queueId;

      if (queueId)
        queue_names.push({
          queue_name: queueId,
        });
    } else {
      queue_names = listChatQueueId
        .filter((queue) => Boolean(queue.queueId))
        .map((queue) => ({
          queue_name: queue.queueId,
        }));
    }

    if (queue_names.length === 0) {
      yield put(setRingmeReportChatByDate([]));
      yield put(setLoadingRingmeReportChatByDate(false));
      return;
    }

    const params = {
      from_date,
      to_date,
      type,
    };

    const payload = {
      queue_names,
    };

    const res = yield call(getRingmeReportChatByDateApi, {
      params,
      payload,
    });

    const reportChatByDate = res.data.data.reduce(
      (prevValue, reportByQueue) => {
        reportByQueue.data_report.forEach((reportDateOfQueue) => {
          const specificDate = prevValue.find(
            (element) => element.date === reportDateOfQueue.date
          );
          if (specificDate) {
            specificDate.report = {
              done_thread:
                specificDate.report.done_thread +
                reportDateOfQueue.report.done_thread,
              missed_thread:
                specificDate.report.missed_thread +
                reportDateOfQueue.report.missed_thread,
              total_thread_agent:
                specificDate.report.total_thread_agent +
                reportDateOfQueue.report.total_thread_agent,
            };
          } else {
            prevValue.push({
              date: reportDateOfQueue.date,
              report: reportDateOfQueue.report,
            });
          }
        });
        return prevValue;
      },
      []
    );

    yield put(setRingmeReportChatByDate(reportChatByDate));
  } catch (error) {
    console.error(error);
  }

  yield put(setLoadingRingmeReportChatByDate(false));
};

export const fetchRingmeListQueueIdFlow = function* (action) {
  try {
    const { type, listChatDepartmentId } = action.payload;

    const res = yield all(
      listChatDepartmentId.map((chatDepartmentId) =>
        call(getDepartmentQueueApi, {
          type: DEPARTMENT_QUEUE_TYPES[type].value,
          cityCode: chatDepartmentId,
        })
      )
    );

    yield put(
      setRingmeListChatQueueId(
        res.map((item, index) => ({
          chatDepartmentId: listChatDepartmentId[index],
          queueId: item.data.queueId,
        }))
      )
    );
  } catch (error) {
    console.error(error);
  }
};

export const getListChatTicketHistoryByUsernameFlow = function* () {
  yield takeLatest("GET_LIST_CHAT_TICKET_HISTORY", fetchListChatTicketHistory);
};

export const getCustomerChatHistoryFlow = function* () {
  yield takeLatest(GET_CUSTOMER_CHAT_HISTORY, fetchCustomerChatHistoryFlow);
};

export const getRingmeChatReportByHourFlow = function* () {
  yield takeLatest(
    GET_RINGME_REPORT_CHAT_BY_HOUR,
    fetchRingmeReportChatByHourFlow
  );
};

export const getRingmeChatReportByDateFlow = function* () {
  yield takeLatest(
    GET_RINGME_REPORT_CHAT_BY_DATE,
    fetchRingmeReportChatByDateFlow
  );
};

export const getRingmeListChatQueueIdFlow = function* () {
  yield takeLatest(GET_RINGME_LIST_CHAT_QUEUE_ID, fetchRingmeListQueueIdFlow);
};

// api
export const changeAgentChatStatusApi = (status, isLogout = false) => {
  return apiCaller.postRequestPreserve(`/call-center/agent/chat-status`, {
    status,
    isLogout,
  });
};

export const getAgentChatInfoApi = () => {
  return apiCaller.getRequest("/id/user/chat-info");
};

export const getAgentChatStatisticApi = () => {
  return apiCaller.getRequest("/call-center/agent/chat-report");
};

export const getCustomerChatHistoryApi = (params) => {
  return axios.post(
    `${process.env.REACT_APP_RING_ME_CHAT_HOST}/sdkapi/s2s/report/get/his/message`,
    null,
    { params }
  );
};

export const getListChatTicketHistoryApi = (where) => {
  return apiCaller.getLogs("/mini-crm/ticket/history", {
    where,
    order: "createdAt DESC",
  });
};

export const getRingmeReportChatByDateApi = ({ params, payload }) => {
  return axios.post(
    `${process.env.REACT_APP_RING_ME_CHAT_HOST}/sdkapi/s2s/report/by/date`,
    payload,
    { params }
  );
};

export const getRingmeReportChatByHourApi = ({ params, payload }) => {
  return apiCaller.postRequest(
    `${process.env.REACT_APP_RING_ME_CHAT_HOST}/sdkapi/s2s/report/by/hour`,
    payload,
    {
      params,
    }
  );
};

export const getDepartmentQueueApi = (payload) => {
  return apiCaller.getRequest(API_URL.DEPARTMENT_QUEUE, payload);
};
